// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cfb4jZOYTpkNtV {
  display: flex;
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.XWd4EAlY2eFdyb {
  margin-left: var(--ds-space-050, 4px);
  color: var(--ds-text-danger, #ae2a19);
}
`, ""]);
// Exports
export var wrapper = `Cfb4jZOYTpkNtV`;
export var message = `XWd4EAlY2eFdyb`;
export default ___CSS_LOADER_EXPORT___;
